const StlUpload = {
  message1: 'Subir STLs de escaneo',
  maxFiles: 1,
  message2: 'Arrastre aquí el archivo STL .zip o de un click aquí para seleccionar uno desde su máquina',
  message3: 'Cargar STL',
  message4: 'Cantidad de archivos que puede cargar: '
}

export default StlUpload
